import { hyphenateHTMLSync } from "hyphen/fi"
import React, { useRef } from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { useMediaQuery } from "react-responsive"

import Button from "@atoms/Button/Button"
import Image from "@atoms/Image/Image"
import Overlay from "@atoms/Overlay/Overlay"

import styles from "./Hero.module.scss"

const Hero = ({
  title,
  headingSize,
  cappedWidth,
  image,
  imageMobile,
  overlay,
  overlayCustom,
  dominantColorEnabled,
  imagePreload,
  isWide,
  variant,
  cta,
}) => {
  const Heading = headingSize

  const cappedClass = cappedWidth
    ? "section-capped-width"
    : "section-full-width"

  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  })

  const link = useRef()

  // Why proxylink?
  // "It's not disastrous in terms of comprehension, but verbose..."
  // (https://inclusive-components.design/cards/)

  const proxyLink = () => {
    link.current.click()
  }

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  return (
    <>
      <section
        className={`${styles.hero} ${cappedClass} ${
          variant ? styles[variant] : null
        } section-break-out section-break-out-no-margins-mobile large-area-element`}
      >
        {image && (
          <div className={styles.image}>
            <Image
              image={isMobile && imageMobile ? imageMobile : image}
              fill={true}
              dominantColorEnabled={dominantColorEnabled}
              blurred={240}
              widths={[480, 720, 1080, 1440, 1600]}
              preload={imagePreload}
            />
          </div>
        )}
        {overlay && <Overlay overlay={overlay} custom={overlayCustom} />}

        <div className={`${styles.container} container`}>
          <div className="make-full-width-on-mobile-with-paddings">
            <Row>
              <Col lg={{ span: 12, offset: 0 }}>
                <div
                  className={`${styles.content} ${
                    isWide ? styles.isWide : null
                  }`}
                >
                  <div
                    className={`${styles.heading} ${
                      cta ? styles.headingCta : ""
                    }`}
                    onClick={cta ? proxyLink : undefined}
                  >
                    <Heading>
                      {title
                        ? hyphenateHTMLSync(title, { minWordLength: 16 })
                        : ""}
                    </Heading>
                    {cta && (
                      <div className={styles.cta}>
                        <Button
                          href={cta.url}
                          linkTarget={cta.target}
                          variant="primary"
                          internalLink={true}
                          ref={link}
                        >
                          {cta.title}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </>
  )
  /* eslint-enable */
}

Hero.defaultProps = {
  dominantColorEnabled: false,
  headingSize: "h1",
}

export default Hero
